// extracted by mini-css-extract-plugin
export default {"image":"iZ-z","loaded":"jZ-z"};